import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { useAppSelector } from '../../redux/hooks';

/**
 * Coordinator review round 6: SearchPanel's own counts (the launchpad's "Right now: N open
 * jobs", the typing-state lens) must match the SRP's own scope exactly, which is gated by the
 * `finlandFilter` Redux slice's `enabled` flag (the World/Finland toggle in
 * `LocationHierarchyPicker.tsx`/`FinlandFilterToggle`, read the same way `SearchContext.tsx`
 * itself reads it: `state.finlandFilter?.enabled ?? true`). Before this, `server/utils/
 * search-panel.ts` always applied the Finland-only baseline regardless of that flag, so with
 * World selected the panel's counts silently disagreed with the SRP's own h1 count.
 *
 * Same guard `useRecentSearchesForPanel.ts`/`useValueSheetLedger.ts` already use: hosts other
 * than the SRP's own Autocomplete (the navbar launchers, MobileBottomNav, the static island) have
 * no Redux Provider mounted at all, so this returns the Finland-scoped default (`true`) for them,
 * which matches the product default everywhere except the SRP itself.
 */
export function useFinlandScopeEnabled(): boolean {
  const hasReduxStore = useContext(ReactReduxContext) != null;
  // eslint-disable-next-line react-hooks/rules-of-hooks -- stable for the component's lifetime, see comment above (matches useRecentSearchesForPanel.ts)
  return hasReduxStore ? useFinlandScopeEnabledFromStore() : true;
}

function useFinlandScopeEnabledFromStore(): boolean {
  return useAppSelector((state) => state.finlandFilter?.enabled ?? true);
}
